// Sugalarm — /api/dev wrappers (cycle 67).
//
// These call the dev injection harness. The harness is gated server-
// side by `SUGALARM_DEV_INJECT_ENABLED`; when disabled every route
// returns 404. The client feature-detects through `/api/health.dev_inject_enabled`
// (see `useDevInjectEnabled`) so this file never has to ship a "dev
// build" — it's just inert on production.

import { request } from "../lib/apiClient";
import type { Alert, ApiResult } from "../lib/types";

export interface InjectReadingOut {
  reading_id: string;
  member_id: string;
  sgv: number;
  timestamp: string;
  alert: Alert | null;
}

export function injectReading(
  memberId: string,
  sgv: number,
  trend: string = "Flat",
  // Cycle 82: optional reading timestamp (ISO). The recovery-dwell
  // repro back-dates readings so the engine's reading-timestamp dwell
  // is satisfied deterministically without a 90 s real-time wait.
  at?: string,
): Promise<ApiResult<InjectReadingOut>> {
  return request<InjectReadingOut>("/api/dev/inject-reading", {
    method: "POST",
    body: { member_id: memberId, sgv, trend, ...(at ? { at } : {}) },
  });
}

export interface DevCleanupOut {
  readings_deleted: number;
  alerts_deleted: number;
}

export function cleanupSynthetic(
  memberId: string,
): Promise<ApiResult<DevCleanupOut>> {
  return request<DevCleanupOut>(
    `/api/dev/test-alerts?member_id=${encodeURIComponent(memberId)}`,
    { method: "DELETE" },
  );
}
